// eslint-disable-next-line 
export const plantSelectionEnum = Object.freeze({
  automatic: 1,
  none: 2,
});

export const plantSelectionTypesEnum = Object.freeze({
  presentAccordingToModelIds: 'presentAccordingToModelIds',
  presentAccordingToUserIds: 'presentAccordingToUserIds',
  pickedFromAdviceIds: 'pickedFromAdviceIds',
});
